import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** One status, one colour, on every surface (§11). Squared radius, no dot. */
export type Tone = 'available' | 'assigned' | 'locked' | 'oos' | 'checkedin' | 'paid' | 'unpaid' | 'declined' | 'warning' | 'danger' | 'success' | 'info' | 'neutral' | 'brand';

const tones: Record<Tone, string> = {
  available: 'text-st-available bg-st-available/12 ring-st-available/30',
  assigned: 'text-st-assigned bg-st-assigned/12 ring-st-assigned/30',
  locked: 'text-st-locked bg-st-locked/12 ring-st-locked/30',
  oos: 'text-st-oos bg-st-oos/12 ring-st-oos/30',
  checkedin: 'text-st-checkedin bg-st-checkedin/12 ring-st-checkedin/30',
  paid: 'text-st-paid bg-st-paid/12 ring-st-paid/30',
  unpaid: 'text-st-unpaid bg-st-unpaid/12 ring-st-unpaid/30',
  declined: 'text-st-declined bg-st-declined/12 ring-st-declined/30',
  warning: 'text-st-warning bg-st-warning/12 ring-st-warning/30',
  danger: 'text-st-danger bg-st-danger/12 ring-st-danger/30',
  success: 'text-st-success bg-st-success/12 ring-st-success/30',
  info: 'text-st-info bg-st-info/12 ring-st-info/30',
  neutral: 'text-ink-2 bg-surface-2 ring-line-strong',
  brand: 'text-ink bg-brand-tint ring-brand/40',
};

export function Badge({ tone = 'neutral', children, className, title, 'data-testid': testId }: { tone?: Tone; children: ReactNode; className?: string; title?: string; 'data-testid'?: string }) {
  return (
    <span title={title} data-testid={testId} className={cn('inline-flex items-center gap-1 whitespace-nowrap rounded-chip px-1.5 py-0.5 text-[12px] font-semibold ring-1 ring-inset', tones[tone], className)}>
      {children}
    </span>
  );
}

export const ROOM_STATE_TONE: Record<string, Tone> = {
  Available: 'available',
  Assigned: 'assigned',
  Locked: 'locked',
  'Out of Service': 'oos',
  'Checked In': 'checkedin',
};
export const INVOICE_TONE: Record<string, Tone> = { Paid: 'paid', 'Deposit Paid': 'warning', Partial: 'warning', Unpaid: 'unpaid', Processing: 'info', Refunded: 'neutral', Void: 'danger', Overdue: 'danger' };
